<template>
    <div class="home-result-list flight-select selectors osago-issue-page" v-if="searchOptions">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="params-search">
                        <a
                            class="params-search__toggler collapsed"
                            data-toggle="collapse"
                            data-target="#searchcollapse"
                            aria-expanded="false"
                            aria-controls="#searchcollapse"
                        >
                            <span>Параметри пошуку</span>
                            <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.2795 2.75059e-08L11 0.69496L5.5 6L-2.31891e-07 0.694961L0.7205 4.45343e-07L5.50275 4.61273L10.2795 2.75059e-08Z" fill="black"/>
                            </svg>
                            <span class="mob">Змінити</span>
                        </a>
                        <transition name="transition-search-form">
                            <div class="collapse" id="searchcollapse">
                                <div class="params-search__content">
                                    <HomeSearchForm
                                        :data-home-type="searchOptions.homeType"
                                        :data-insurance-amount="searchOptions.insuranceAmount"
                                        :data-insurance-period="searchOptions.insurancePeriod"
                                        :data-start-date="searchOptions.startDate"
                                        :data-earning="searchOptions.earning"
                                        :data-show-banner="false"
                                    />
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="row flex-lg-row-reverse">
                <div class="col-lg-4">
                    <div class="sticky-wrapp">
                        <HomePolicy :can-edit="true" />
                        <HomePromo />
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="col-12 position-relative results" v-if="!offers.length">
                        <div class="results_anime">
                            <div class="results_anime_circles">
                                <div class="waiting_animation">
                                    <div class="background">
                                        <div class="loader loader-left"></div>
                                        <div class="loader loader-right"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="results_anime_percent">
                                <span class="results_anime_percent-text"></span>
                            </div>
                            <div class="results_anime_line">
                                <span class="results_anime_line-scale" :style="`width: 1%;`"></span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flight-results__top">
                        <div class="flight-results__heading">Знайдено: <span>{{ offers.length }}</span></div>
                        <div class="osago-offers__earnings greencard-earnings">
                            <button v-if="!showEarnings" @click="showEarnings = true" type="button">
                                <svg style="margin-bottom: 5px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0)">
                                        <path d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#24282C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0">
                                            <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span>Показати заробіток</span>
                            </button>
                            <button v-if="showEarnings" @click="showEarnings = false" type="button">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.11649 5.0665C9.4088 5.02169 9.70411 4.9994 9.99983 4.99983C12.6498 4.99983 15.1415 6.90816 16.5915 9.99983C16.3697 10.4703 16.1193 10.9267 15.8415 11.3665C15.7533 11.503 15.707 11.6623 15.7082 11.8248C15.71 12.0067 15.7713 12.183 15.8827 12.3267C15.9941 12.4705 16.1495 12.5739 16.3251 12.6211C16.5008 12.6683 16.687 12.6568 16.8555 12.5882C17.024 12.5197 17.1654 12.3979 17.2582 12.2415C17.6464 11.6314 17.9837 10.9904 18.2665 10.3248C18.3112 10.2208 18.3343 10.1088 18.3343 9.99566C18.3343 9.88248 18.3112 9.77048 18.2665 9.6665C16.5832 5.75816 13.4165 3.33316 9.99983 3.33316C9.60872 3.33119 9.21823 3.36466 8.83316 3.43316C8.72373 3.45177 8.61903 3.49174 8.52504 3.55081C8.43106 3.60988 8.34963 3.68688 8.2854 3.77741C8.22117 3.86795 8.17541 3.97025 8.15072 4.07848C8.12602 4.1867 8.12289 4.29873 8.1415 4.40816C8.1601 4.5176 8.20008 4.6223 8.25914 4.71628C8.31821 4.81027 8.39521 4.8917 8.48575 4.95592C8.57628 5.02015 8.67858 5.06592 8.78681 5.09061C8.89503 5.1153 9.00706 5.11843 9.11649 5.09983V5.0665ZM3.0915 1.90816C3.0138 1.83046 2.92155 1.76883 2.82004 1.72678C2.71852 1.68473 2.60971 1.66309 2.49983 1.66309C2.38995 1.66309 2.28114 1.68473 2.17962 1.72678C2.0781 1.76883 1.98586 1.83046 1.90816 1.90816C1.75124 2.06508 1.66309 2.27791 1.66309 2.49983C1.66309 2.72175 1.75124 2.93458 1.90816 3.0915L4.4915 5.6665C3.31281 6.8011 2.37471 8.16148 1.73316 9.6665C1.68728 9.77163 1.66359 9.88511 1.66359 9.99983C1.66359 10.1145 1.68728 10.228 1.73316 10.3332C3.4165 14.2415 6.58316 16.6665 9.99983 16.6665C11.4974 16.6561 12.9596 16.2102 14.2082 15.3832L16.9082 18.0915C16.9856 18.1696 17.0778 18.2316 17.1793 18.2739C17.2809 18.3162 17.3898 18.338 17.4998 18.338C17.6098 18.338 17.7188 18.3162 17.8203 18.2739C17.9219 18.2316 18.014 18.1696 18.0915 18.0915C18.1696 18.014 18.2316 17.9219 18.2739 17.8203C18.3162 17.7188 18.338 17.6098 18.338 17.4998C18.338 17.3898 18.3162 17.2809 18.2739 17.1793C18.2316 17.0778 18.1696 16.9856 18.0915 16.9082L3.0915 1.90816ZM8.39149 9.56649L10.4332 11.6082C10.2923 11.6486 10.1463 11.6682 9.99983 11.6665C9.5578 11.6665 9.13388 11.4909 8.82132 11.1783C8.50876 10.8658 8.33316 10.4419 8.33316 9.99983C8.33146 9.85332 8.35111 9.70734 8.39149 9.56649ZM9.99983 14.9998C7.34983 14.9998 4.85816 13.0915 3.4165 9.99983C3.9549 8.81129 4.71906 7.73864 5.6665 6.8415L7.1415 8.33316C6.79503 8.96549 6.66295 9.69312 6.76504 10.4069C6.86714 11.1206 7.19793 11.782 7.70777 12.2919C8.21761 12.8017 8.87902 13.1325 9.59278 13.2346C10.3065 13.3367 11.0342 13.2046 11.6665 12.8582L12.9915 14.1665C12.0841 14.7006 11.0527 14.9879 9.99983 14.9998Z" fill="#24282C"/>
                                </svg>
                                Сховати заробіток
                            </button>
                        </div>
                    </div>
                    <div v-if="offers.length" class="result-list new-list flight-list">
                        <HomeConcreteProposal v-for="(offer, index) in offers" :key="index" :offer="offer" :show-earnings="showEarnings" :payer="payer" :house-info="houseInfo" />
                        <div class="col-12 text-center"><button class="result-list__scrolltop" @click="scrollTop"><span>Вгору</span></button></div>
                    </div>
                    <div v-if="!loading && !offers.length" style="margin-top: 40px; text-align: center;">За запитом пропозицій не знайдено, змініть параметри пошуку.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HomeSearchForm from "@/views/home/components/HomeSearchForm.vue";
import HomePolicy from "@/views/home/components/HomePolicy.vue";
import HomeConcreteProposal from "@/views/home/components/HomeConcreteProposal.vue";
import { list as homeInsuranceCompanyList } from '@/api/homeInsuranceCompany';
import HomePromo from "@/views/home/components/HomePromo.vue";

export default {
    components: { HomePromo, HomeSearchForm, HomePolicy, HomeConcreteProposal },

    data() {
        return {
            loading: false,
            searchOptions: {
                homeType: null,
                insuranceAmount: null,
                insurancePeriod: null,
                startDate: null,
                earning: null
            },
            offers: [],
            showEarnings: false,
            payer: {
                documentType: 1,
                identificationCode: null,
                erdpyCode: null,
                withoutIdentificationCode: false,
                withoutDocuments: false,
                name: null,
                name_ua: null,
                surname: null,
                surname_ua: null,
                patronymic_ua: null,
                dateBirth: null,
                phone: null,
                mail: null,
                city: null,
                street: null,
                house: null,
                apartment: null,
                internationalPassport: null,
                passportSerial: null,
                passportNumber: null,
                passportCompany: null,
                passportDate: null,
                documentation: {
                    //TODO текущее значение нобходимо будет брать с словаря(api)
                    type: 1,
                    serial: null,
                    number: null,
                    issuedBy: null,
                    dateOfIssue: null,
                    endDateOfIssue: null,
                    dateOfIssueError: false,
                },
            },
            houseInfo: {
                city: null,
                street: null,
                house: null,
                apartment: null,
            },
        }
    },

    created() {
        this.fillCalculatorOptions();
        this.fetchOffers();
        this.$store.commit('SET_CLIENT', null);
    },

    methods: {
        fillCalculatorOptions() {
            const params = this.$store.getters.HOME_SEARCH_PARAMS;
            this.searchOptions.homeType = params.homeType;
            this.searchOptions.insuranceAmount = params.insuranceAmount;
            this.searchOptions.insurancePeriod = params.insurancePeriod;
            this.searchOptions.startDate = params.startDate;
            this.searchOptions.earning = params.earning;
        },

        sortPriceEarnings(offers) {
            return offers.sort(function (a, b) {
                if (Math.round((a.earnings / a.price) * 100) > Math.round((b.earnings / b.price) * 100)) {
                    return -1;
                }

                if (Math.round((b.earnings / b.price) * 100) > Math.round((a.earnings / a.price) * 100)) {
                    return 1;
                }

                return 0;
            });
        },

        fetchOffers() {
            this.loading = true;
            const params = this.$store.getters.HOME_SEARCH_PARAMS;

            homeInsuranceCompanyList(
                params.homeType.param,
                params.insuranceAmount.param,
                params.insurancePeriod.param,
                params.startDate,
                params.earning.value
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    this.offers = response?.data?.data;
                    this.sortPriceEarnings(this.offers);

                    return true;
                }
            }).catch((error) => {
                this.$alert('Щось пішло не так. Перевірте параметри пошуку.');
            }).finally(() => {
                this.loading = false;
            });
        },

        scrollTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    },
}
</script>
